import Component from '../core/Component'
import { EMITS as AUTOCOMPLETE_EMITS } from './Autocomplete'
import { EMITS as GPSRETRIEVER_EMITS } from './GpsRetriever'

export default class ContactSearch extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            autocomplete: null,
            gpsRetriever: null,
            form: null,
            lat: null,
            lng: null,
            id: null
        }
    }

    prepare() {
        if (this.ref.autocomplete) {
            this.autocomplete = Component.getFromElement(this.ref.autocomplete)
            this.autocomplete.on(AUTOCOMPLETE_EMITS.SELECT, this.handleAutocompleteSelect)
        }

        if (this.ref.gpsRetriever) {
            this.gpsRetriever = Component.getFromElement(this.ref.gpsRetriever)
            this.gpsRetriever.on(GPSRETRIEVER_EMITS.POSITION_FETCHED, this.handleGpsRetrieverPositionFetched)
        }

        if (this.ref.form) {
            this.ref.form.addEventListener('change', this.handleChange)
        }
    }

    //kdyz se klikne na gpsku, submitne to jen lat,lng a query
    handleGpsRetrieverPositionFetched = ({ lat, lng }) => {
        this.setOrClearValues({
            lat,
            lng
        })
        this.ref.form.submit()
    }

    //kdyz se vybere z autocomplete, submitne se jen id a query
    handleAutocompleteSelect = async () => {
        const value = await this.autocomplete.getValue()
        this.setOrClearValues({
            id: value?.id
        })
        this.ref.form.submit()
    }

    //kdyz se zmeni autocomplete, promazat id,lat,lng, aby submit poslal jen query
    handleAutocompleteChange = () => {
        this.setOrClearValues()
    }

    setOrClearValues({ lat, lng, id } = {}) {
        this.ref.id.value = id ?? ''
        this.ref.lat.value = lat ?? ''
        this.ref.lng.value = lng ?? ''
    }
}